import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseApiService } from '../../../core/services/base-api.service';
import { CampaignPerformance, CampaignPerformanceRate } from '../../../shared/services/campaign.service';
import { AppConfigService } from '../../../core/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignPerformanceService extends BaseApiService {
  constructor(http: HttpClient, appConfigService: AppConfigService) {
    super(http, appConfigService);
  }

  /**
   * Get performance data for a specific campaign
   * @param campaignName Campaign name
   * @returns Observable of CampaignPerformance
   */
  getCampaignPerformance(campaignName: string): Observable<CampaignPerformance> {
    return this.get<any>(`campaigns/campaign-performance?campaignName=${campaignName}`)
      .pipe(
        map(response => {
          // If the API returns just the campaign name, we need to create a mock performance object
          if (response && typeof response === 'object' && response.campaignName) {
            return response as CampaignPerformance;
          } else if (Array.isArray(response) && response.length > 0) {
            return response[0] as CampaignPerformance;
          } else {
            // If we don't have proper data, return a default object
            return {
              campaignName: campaignName || 'Unknown Campaign',
              sent: 0,
              delivered: 0,
              opened: 0,
              clicked: 0,
              bounced: 0,
              unsubscribes: 0
            };
          }
        }),
        catchError(error => {
          console.error('Error fetching campaign performance:', error);
          return of({
            campaignName: campaignName || 'Error Loading Data',
            sent: 0,
            delivered: 0,
            opened: 0,
            clicked: 0,
            bounced: 0,
            unsubscribes: 0
          });
        })
      );
  }

  getCampaignPerformanceRate(campaignName: string): Observable<CampaignPerformanceRate> {
    const encodedCampaignName = encodeURIComponent(campaignName);
    return this.get<any>(`campaigns/campaign-performance-rate?CampaignName=${encodedCampaignName}`)
      .pipe(
        map(response => {
          // If the API returns just the campaign name, we need to create a mock performance rate object
          if (response && typeof response === 'object' && response.campaignName) {
            return response as CampaignPerformanceRate;
          } else if (Array.isArray(response) && response.length > 0) {
            return response[0] as CampaignPerformanceRate;
          } else {
            // If we don't have proper data, return a default object
            return {
              campaignName: campaignName || 'Unknown Campaign',
              openRate: 0,
              ctor: 0,
              ctr: 0,
              unsubscribeRate: 0,
              bounceRate: 0
            };
          }
        }),
        catchError(error => {
          console.error('Error fetching campaign performance rate:', error);
          return of({
            campaignName: campaignName || 'Error Loading Data',
            openRate: 0,
            ctor: 0,
            ctr: 0,
            unsubscribeRate: 0,
            bounceRate: 0
          });
        })
      );
  }
} 